const MIDTRANS_IS_PRODUCTION = String(process.env.REACT_APP_MIDTRANS_IS_PRODUCTION || "").toLowerCase() === "true";
const MIDTRANS_CLIENT_KEY = String(process.env.REACT_APP_MIDTRANS_CLIENT_KEY || "").trim();
const MIDTRANS_SNAP_URL =
  String(process.env.REACT_APP_MIDTRANS_SNAP_URL || "").trim() ||
  (MIDTRANS_IS_PRODUCTION
    ? "https://app.midtrans.com/snap/snap.js"
    : "https://app.sandbox.midtrans.com/snap/snap.js");

let snapReadyPromise = null;

function waitForSnap(resolve, reject, timeoutMs = 10000) {
  const start = Date.now();
  const timer = setInterval(() => {
    if (window.snap) {
      clearInterval(timer);
      resolve(window.snap);
      return;
    }
    if (Date.now() - start >= timeoutMs) {
      clearInterval(timer);
      reject(new Error("Midtrans Snap timeout"));
    }
  }, 100);
}

export function ensureMidtransSnapReady(timeoutMs = 10000) {
  if (window.snap) return Promise.resolve(window.snap);
  if (!MIDTRANS_CLIENT_KEY) {
    return Promise.reject(new Error("Midtrans client key missing"));
  }

  if (!snapReadyPromise) {
    snapReadyPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-midtrans-snap="1"]');
      if (existing) {
        waitForSnap(resolve, reject, timeoutMs);
        return;
      }

      const script = document.createElement("script");
      script.src = MIDTRANS_SNAP_URL;
      script.async = true;
      script.setAttribute("data-client-key", MIDTRANS_CLIENT_KEY);
      script.setAttribute("data-midtrans-snap", "1");
      script.onload = () => waitForSnap(resolve, reject, timeoutMs);
      script.onerror = () => reject(new Error("Failed to load Midtrans Snap"));
      document.head.appendChild(script);
    }).catch((err) => {
      snapReadyPromise = null;
      throw err;
    });
  }

  return snapReadyPromise;
}
